import withDirection from 'src/settings/withDirection';
import styled from 'styled-components';
import { palette } from 'styled-theme';

const SearchFooterStyles = styled('div')`
  border-top: 1px solid ${palette('border', 1)};
  padding: 8px 16px 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0px;
  color: ${palette('grayscale', 7)};
  display: flex;

  .footer-action-group {
    display: flex;
    margin-left: ${props => (props['data-rtl'] === 'rtl' ? '16px' : '0')};
    margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '16px')};
    align-items: center;
  }

  .keyboard-shortcut-key {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    border: 1px solid ${palette('border', 1)};
    background-color: ${palette('globalSearch', 0)};
    margin-left: ${props => (props['data-rtl'] === 'rtl' ? '5px' : '0')};
    margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '5px')};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .keyboard-shortcut-enter {
    width: 32px;
    height: 20px;
    border-radius: 5px;
    border: 1px solid ${palette('border', 1)};
    background-color: ${palette('globalSearch', 0)};
    margin-left: ${props => (props['data-rtl'] === 'rtl' ? '5px' : '0')};
    margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '5px')};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const SearchFooter = withDirection(SearchFooterStyles);
